var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderMoveTo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 6.125L9.36875 7.00625L10.9813 8.625H5.25V9.875H10.9813L9.36875 11.4938L10.25 12.375L13.375 9.25L10.25 6.125Z",
    fill: "#717A97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9825 1.75L8.11625 3.88375L8.4825 4.25H16.5V14.25H1.5V1.75H5.9825ZM5.9825 0.5H1.5C1.16848 0.5 0.850537 0.631696 0.616116 0.866116C0.381696 1.10054 0.25 1.41848 0.25 1.75V14.25C0.25 14.5815 0.381696 14.8995 0.616116 15.1339C0.850537 15.3683 1.16848 15.5 1.5 15.5H16.5C16.8315 15.5 17.1495 15.3683 17.3839 15.1339C17.6183 14.8995 17.75 14.5815 17.75 14.25V4.25C17.75 3.91848 17.6183 3.60054 17.3839 3.36612C17.1495 3.1317 16.8315 3 16.5 3H9L6.86625 0.86625C6.63188 0.631813 6.31399 0.500071 5.9825 0.5Z",
    fill: "#717A97"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderMoveTo);
export default __webpack_public_path__ + "static/media/folder-move-to.acc2a3263820d2290b6a1acddfdea175.svg";
export { ForwardRef as ReactComponent };